export default function isSome(value) {
	return value !== null && value !== undefined;
}



// WEBPACK FOOTER //
// ./src/core/utils/isSome.js